import clsx from 'clsx';

export function EmptyState({ title, description, action, className }) {
  return (
    <div className={clsx('animate-fade-in flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-border bg-surface px-6 py-14 text-center', className)}>
      <p className="text-sm font-medium text-ink">{title}</p>
      {description && <p className="text-xs text-ink-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
